import { FieldError, FieldValues, useFormContext } from 'react-hook-form';

export const useCombinedFormErrors = <TFormFields extends FieldValues>(
    keys: Readonly<(keyof TFormFields)[]>
) => {
    const {
        formState: { errors },
    } = useFormContext<TFormFields>();

    // NOTE: can't use memo here, the errors object is mutated, not recreated
    const relevantErrors = keys
        .map(x => errors[x])
        .filter(x => !!x)
        .map(x => x!);

    if (relevantErrors.length === 0) {
        return undefined;
    }

    // arrgh, this is all so messy. I need to clean this up
    const custom: FieldError = {
        type: 'custom-combined',
        message: relevantErrors
            .map(x => (x.type === 'required' ? 'This field is required' : x.message))
            .join(', '),
    };

    return custom;
};
